import { useState, useEffect } from "react"
import Cookies from 'js-cookie';
// import { IoMdArrowRoundUp } from "react-icons/io";
// import { IoMdArrowRoundDown } from "react-icons/io";
import Navbar from './NavBar';
import axios from "axios";
import { TailSpin } from 'react-loader-spinner'
// import Breadcrumbs from './BreadCrumbs';
import { useParams } from 'react-router-dom';
import Nodata from '../../assets/No data.png'
import { toast,ToastContainer } from "react-toastify";
import { MdClear } from "react-icons/md";


const SuperAdminTransactionsPage =()=>{
    const token = Cookies.get('jwt_token')
    const [currentPage, setCurrentPage] = useState(1);
    const [entries,setEntries]=useState(15)
    const [categorySearch,setCategorySearch]=useState('')
    const [userLoading,setUserLoading]=useState(true)
    const [transactions, setTransactions] = useState([]);
    // console.log(transactions)
    const { id } = useParams();
    const moment = require('moment');

    const totalPages = Math.ceil(transactions.length / entries);
    const startIndex = parseInt((currentPage - 1) * entries);
    const currentItems = transactions.slice(startIndex, startIndex + entries);

    const handlePageChange = (page) => {
        setCurrentPage(page);
      };

    //  const breadcrumbsData = [
    //     { label: "Dashboard", link: "../super-admin/dashboard" },
    //     { label: "Account's Transaction List", current: true },
    //   ];

    const getTransactions = async (id) => {
        try {
          setUserLoading(true);
          const response = await axios.get(
            `https://bankdata.inclineanalytics.com/api/all-transactions/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
              params: {
                categorySearch: categorySearch,
              },
            }
          );
          if(response.data.success){
            setTransactions(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching Transaction list", error);
          toast.error("Error fetching Transaction list, Try again!");
        } finally {
          setUserLoading(false);
        }
      };
      

    useEffect(() => {
        getTransactions(id)
  // eslint-disable-next-line
    },[entries,categorySearch,id]);

    const updateCategorySearch=(event)=>{
        setCategorySearch(event.target.value)
        setCurrentPage(1)
    }

    const handleChangeEntries = (event) => {
        setEntries(parseInt(event.target.value));
        setCurrentPage(1);
      };

    return(
        <div className='bg-[#001f3f] max-h-[100vh] h-screen overflow-y-auto'>
            <Navbar />
            <ToastContainer/>
            {/* <Breadcrumbs items={breadcrumbsData} /> */}
            <div className="flex justify-between items-center mt-2 mr-12 items-center">
            <h1 className="text-left ml-12 mt-3 text-2xl font-semibold text-[#ff6f61]">Account's Transaction List:</h1>
                <div className="bg-[#ffffff] p-1 flex justify-between w-[280px]  border rounded-lg border-[#ff6f61]">
                <input type="text" className="border-0 ml-2 w-[230px] focus:outline-none" onChange={updateCategorySearch} value={categorySearch} placeholder="Enter search category"/>
                {categorySearch !== "" && <button type="button" onClick={()=>{
                    setCategorySearch('')
                }} className="font-semibold flex flex-col justify-center ml-3 hover:text-[#ff6f61] "><MdClear/></button>
            }
            </div>
            </div>
            <div className=" m-12 mt-1 mb-4 bg-[#ffffff] h-[65vh] rounded-lg overflow-auto scrollbar-thin scrollbar-thumb-gray-800 scrollbar-track-gray-300">
              {userLoading?<div className="flex flex-col justify-center items-center h-full">
                <TailSpin
                    visible={true}
                    height="80"
                    width="80"
                    color="#ff6f61"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""/></div>:<>{
                transactions.length===0?
                <div className="flex flex-col h-full justify-center items-center">
                <img src={Nodata} alt="no-data" className="h-[350px]"/>
                <h1 className="text-2xl text-gray-800">No Transactions data found</h1>
              </div>:<>
                <div className="w-full  overflow-x p-2">
                <table className="w-full text-sm bg-white mt-2">
                <thead className="bg-[#ff6f61] text-white">
                    <tr>
                        <th className=" px-2">SR No</th>
                        <th className=" px-2">Plaid Transaction Id</th>
                        <th className=" px-2">Name</th>
                        <th className=" px-2">Date</th>
                        <th className=" px-2">Category</th>
                        <th className=" px-2">Amount</th>
                    </tr>
                </thead>
                <tbody>
                {currentItems.map((transaction,index) => (
                    <tr key={transaction.id} className="text-gray-700">
                    <td className="border border-[#faaea7] px-2">{index+1}</td>
                    <td className="border border-[#faaea7] px-2">{transaction.plaidTransactionId}</td>
                    <td className="border border-[#faaea7] px-2">{transaction.name}</td>
                    <td className="border border-[#faaea7] px-2">{moment(transaction.date).format('YYYY-MM-DD')}</td>
                    <td className="border border-[#faaea7] px-2">
                    <ol>
                        {transaction.categoryName.length > 0 ? (
                          transaction.categoryName.map((each, index) => (
                            <li key={index}>
                              {each}
                            </li>
                          ))
                        ) : (
                          <li>N/A</li>
                        )}
                    </ol>
                    </td>
                    <td className={`border border-[#faaea7] px-2 ${transaction.amount > 0 ? 'text-red-600' : 'text-green-600'}`}>$ {transaction.amount}</td>
                    </tr>
                ))}
                </tbody>
                </table> 
                </div>
            </>
              }</>
              }
            </div>
            {transactions.length!==0 && <div className="flex justify-between mr-12 ml-12">
                <div className="">
                    <label htmlFor="number-select" className="text-lg text-[#ff6f61] font-semibold mr-4 ml-2">Entries per Page</label>
                    <select
                        id="number-select"
                        value={entries}
                        onChange={handleChangeEntries}
                        className="border rounded-lg text-black border-[#ff6f61] focus:border-[#ff6f61] focus:outline-none h-8 "
                        >
                            <option value={15}>15</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                    </select>
                </div>
                <div className="flex">
                <button
                onClick={() => handlePageChange(currentPage - 1)}
                className={`rounded-lg  bg-[#ff6f61] text-[#ffffff] m-1 p-2 ${currentPage === 1 ? 'bg-[#fc948b] cursor-not-allowed' : ' hover:shadow-custom-orange focus:outline-none focus:shadow-outline'}`}
                disabled={currentPage === 1}
                >
                Previous
                </button>
                <p className="rounded-full text-[#ff6f61] bg-[#ffffff] font-bold text-xl flex flex-col justify-center items-center pr-3 pl-3 m-1 mr-2 ml-2">{currentPage}</p>
                <button
                onClick={() => handlePageChange(currentPage + 1)}
                className={`rounded-lg bg-[#ff6f61] text-[#ffffff] m-1 p-2 ${currentPage === totalPages ? 'bg-[#fc948b] cursor-not-allowed' : ' hover:shadow-custom-orange focus:outline-none focus:shadow-outline'}`}
                disabled={currentPage === totalPages}
                >
                Next
                </button>
                </div>
            </div>}
            
        </div>
    )
}
export default SuperAdminTransactionsPage